import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-portfolio',
  templateUrl: './portfolio.component.html',
  styleUrls: ['./portfolio.component.scss']
})
export class PortfolioComponent implements OnInit {

  stories;

  constructor() {
    this.stories = [
      {
        id: 1,
        title: 'portfolio.stories.mcatalog.title',
        product: 'portfolio.stories.mcatalog.product',
        imageURL: 'assets/images/mcatalog/kiosk.png',
        url: 'mCatalog'
      },
      {
        id: 2,
        title: 'portfolio.stories.mscan.title',
        product: 'portfolio.stories.mscan.product',
        imageURL: 'assets/images/mscan/mscan_thumbnail.png',
        url: 'mScan'
      },
      {
        id: 3,
        title: 'portfolio.stories.mturn.title',
        product: 'portfolio.stories.mturn.product',
        imageURL: 'assets/images/mturn/mturn_thumbnail.png',
        url: 'mTurn'
      },
      {
        id: 4,
        title: 'portfolio.stories.mbroadcast.title',
        product: 'portfolio.stories.mbroadcast.product',
        imageURL: 'assets/images/mbroadcast/ads.png',
        url: 'mBroadcast'
      },
      {
        id: 5,
        title: 'portfolio.stories.mhelp.title',
        product: 'portfolio.stories.mhelp.product',
        imageURL: 'assets/images/mhelp/help.png',
        url: 'mHelp'
      },
      {
        id: 6,
        title: 'portfolio.stories.mecom.title',
        product: 'portfolio.stories.mecom.product',
        imageURL: 'assets/images/mecom/shopping.png',
        url: 'mEcom'
      },
      {
        id: 7,
        title: 'portfolio.stories.mpay.title',
        product: 'portfolio.stories.mpay.product',
        imageURL: 'assets/images/mpay/online-payment.png',
        url: 'mPay'
      },
      {
        id: 8,
        title: 'portfolio.stories.mchecker.title',
        product: 'portfolio.stories.mchecker.product',
        imageURL: 'assets/images/mchecker/ocr.png',
        url: 'mChecker'
      },
      {
        id: 9,
        title: 'portfolio.stories.mpos.title',
        product: 'portfolio.stories.mpos.product',
        imageURL: 'assets/images/mpos/terminal-pos.png',
        url: 'mPos'
      },
      {
        id: 10,
        title: 'portfolio.stories.minventory.title',
        product: 'portfolio.stories.minventory.product',
        imageURL: 'assets/images/minventory/inventory.png',
        url: 'mInventory'
      }/**,
      {
        id: 9,
        title: 'portfolio.stories.alcampo.title',
        product: 'portfolio.stories.alcampo.product',
        imageURL: 'assets/images/auchan/auchan_thumbnail.png',
        url: 'alcampo'
      },
      {
        id: 10,
        title: 'portfolio.stories.setex.title',
        product: 'portfolio.stories.setex.product',
        imageURL: 'assets/images/setex/setex_thumbnail.png',
        url: 'setex'
      },
      {
        id: 11,
        title: 'portfolio.stories.despinasse.title',
        product: 'portfolio.stories.despinasse.product',
        imageURL: 'assets/images/despinasse/despinasse_thumbnail.png',
        url: 'despinasse'
      } */
    ];
  }

  ngOnInit() { }

}
